<template>
  <div>
    <!-- <div class="tab">Your favorites</div>
    <div class="tab">Suggested</div> -->
    <div class="autocomplete practice-autocomplete mx-auto">
      <!-- eslint-disable-next-line prettier/prettier -->
      <small class="text-hint no-results-label" :style="{ opacity: isOpen && isNoResults ? 1 : 0 }">No Results</small>
      <multiselect
        id="ajax"
        @input="actualSelection = $event && $event.id"
        class="practice-lookup-complete autocomplete-xl"
        :class="{ 'has-error': error }"
        ref="multiselect"
        track-by="id"
        :placeholder="placeholder"
        open-direction="bottom"
        :options="options"
        :multiple="false"
        :searchable="isSearchable"
        :loading="isLoading"
        :internal-search="false"
        :clear-on-select="false"
        :close-on-select="closeOnSelect"
        :options-limit="300"
        :preserve-search="true"
        :limit="5"
        :limit-text="limitText"
        :max-height="600"
        :show-no-results="true"
        :hide-selected="true"
        :custom-label="displayLabel"
        :select-label="''"
        :noResult="'No results found'"
        @search-change="searchChange"
        @select="itemSelected"
        @open="onOpen"
        @close="isOpen = false"
      >
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <div
              v-if="props.option.showAddPractice && isSearchable"
              class="d-flex p-3 align-items-center justify-content-center font-weight-bolder w-100"
              style="font-size: 1rem"
            >
              <a href="javascript:void(0)" @click="isAddPracticeModalVisible = true"
                ><font-awesome-icon :icon="['far', 'plus']" class="mr-2" /> Add a new practice</a
              >
            </div>
            <practice-list-item v-else :item="props.option" @testReferral="itemSelected" />
            <small class="option__entries" v-if="props.option.entries > 1"
              ><b>{{ props.option.entries }} more entries</b></small
            >
          </div>
        </template>
        <template slot="noOptions"><span class="option__title">You have no favourites</span></template>
      </multiselect>

      <div class="text-muted mt-1" v-if="isSearchable">
        <small>Tip: <b>Office phone number</b> search yields the best results</small>
      </div>
      <div v-if="errorMsg" class="text-danger">
        {{ errorMsg }}
      </div>
    </div>
    <add-practice
      @selected="itemSelected"
      :show="isAddPracticeModalVisible"
      @close="isAddPracticeModalVisible = false"
    />
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Multiselect from 'vue-multiselect'
import NpiService from '@/services/NpiService'
import { mapState, mapGetters } from 'vuex'
import AddPractice from './AddPracticeModal.vue'
import Fuse from 'fuse.js'
import PracticeListItem from './PracticeListItem.vue'

export default {
  name: 'PracticeAutoComplete',
  components: { Multiselect, AddPractice, PracticeListItem },
  props: {
    error: { type: Boolean },
    isSearchable: { type: Boolean, default: true },
    placeholder: { type: String, default: 'Find practice' },
    closeOnSelect: { type: Boolean, default: false },
    items: { default: () => [] },
  },
  data() {
    return {
      errorMsg: '',
      results: [],
      isLoading: false,
      searchWithin: undefined, //preventDuplicateFromMultipleEntrySelect
      searchWithinFirst: undefined,
      internalSearch: true,
      actualSelection: undefined,
      query: undefined,
      isAddPracticeModalVisible: false,
      specialtyTab: 0,
      isOpen: false,
      lonlat: null,
    }
  },
  created() {
    this.$_debounceTimer = null
  },
  mounted() {
    // this.$refs.multiselect.activate()
    if (this.isSearchable) this.$store.dispatch('suggested/load')
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('suggested', ['isLoaded', 'suggested']),
    ...mapGetters('suggested', ['withNetwork']),
    ...mapGetters('practices', ['network']),
    nShowFromEachSuggested() {
      return this.user?.is_public ? 3 : 1
    },
    fuseNetwork() {
      return new Fuse(this.network, {
        includeScore: true,
        minMatchCharLength: 2,
        keys: [
          'address',
          'address_2',
          'city',
          'zip',
          '',
          {
            name: 'name',
          },
          'phone',
          'fax',
          {
            name: 'doctors.first_name',
          },
          {
            name: 'doctors.last_name',
          },
          // 'doctors.full_name',
          'email',
        ],
      })
    },
    options() {
      var passedItems = this.items?.length ? this.items : []

      if (passedItems?.length && !this.isSearchable) {
        return [...passedItems]
      }

      const filteredNetwork = this.query
        ? this.fuseNetwork
            .search(this.query)
            ?.filter((s) => s.score < 0.1)
            .map((s) => s.item) || []
        : this.network //this.network.filter(searchObj)

      const filteredResults = this.isLoading
        ? []
        : this.results.filter((s) => !this.network.map((a) => a.id).includes(s.id))
      const suggested = this.isLoading || this.query ? [] : this.highlightSuggested
      const combined = [
        // { showTestPractice: true },
        // { showFilter: true, disabled: true },
        ...filteredNetwork.map((s) => ({ ...s, isInNetwork: true })),
        ...filteredResults,
        ...suggested,
        ...passedItems,
        { showAddPractice: this.isSearchable },
      ]
      return combined
    },
    isNoResults() {
      return !this.isLoading && this.query && this.options.length === 1
    },
    suggestedSpecialties() {
      const isGpOrthoOrPed = [0, 4, 5].includes(this.user?.practice?.specialty || 0)
      return isGpOrthoOrPed
        ? this.user?.is_public
          ? [1, 3, 6, 4, 5]
          : [1, 3, 6] //if a gp, ped or orth show endo, oms, peri
        : [0, 3, 6]
    },
    highlightSuggested() {
      const suggested = this.withNetwork.filter((s) => s.isSuggested)
      return this.suggestedSpecialties
        .map((o) => suggested.filter((s) => s.specialty == o)?.slice(0, this.nShowFromEachSuggested))
        .filter((s) => s?.length)
        .flat()
    },
  },
  methods: {
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer)
      }
      this.$_debounceTimer = setTimeout(() => {
        method()
      }, timer)
    },
    displayLabel(option) {
      return option.name
    },
    itemSelected(option, id) {
      if (option.showAddPractice) this.isAddPracticeModalVisible = true
      if (option.id) {
        if (!this.network.map((s) => s.id).includes(option.id)) {
          this.$store.dispatch('practices/addToNetwork', option)
        }
        this.$emit('selected', option)
      } else return
      this.$refs.multiselect.deactivate()
    },
    limitText(count) {
      return `and ${count} other addresses`
    },
    async searchChange(query) {
      this.debounce(() => {
        this.search(query)
      }, 250)
    },
    async search(query, id) {
      this.query = query
      if (!query) return
      this.errorMsg = ''
      this.isLoading = true
      try {
        this.results = await NpiService.searchAll(query, this.lonlat)
      } catch (e) {
        this.results = []
        console.error(e)
        this.errorMsg = e.error || e.message || e
      }
      this.isLoading = false
    },
    filterSpecialty(s) {
      this.specialtyTab = this.specialtyTab === s ? null : s
    },
    async onOpen() {
      this.isOpen = true
      if (this.isLoaded && !this.suggested?.flat()?.length && this.isSearchable) {
        this.isLoading = true
        try {
          const pos = await this.getLocation()
          if (pos?.coords?.longitude) {
            this.lonlat = { lat: pos.coords.latitude, lon: pos.coords.longitude }
            await this.$store.dispatch('suggested/load', {
              miles: 50,
              ...this.lonlat,
              refresh: true,
            })
          }
        } catch {}
        this.isLoading = false
      }
    },
    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!('geolocation' in navigator)) {
          reject(new Error('Geolocation is not available.'))
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve(pos)
          },
          (err) => {
            reject(err)
          }
        )
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.option__title {
  font-size: 1.075rem;
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 1.5rem;
}
</style>
<style lang="scss">
.practice-autocomplete {
  position: relative;
  .no-results-label {
    position: absolute;
    z-index: 51;
    margin-left: auto;
    right: 52px;
    top: 5px;
    line-height: 32px;
    opacity: 0;
    transition: opacity 150ms ease-in-out;

    &.opactiy-1 {
      opacity: 1;
    }
  }
  .multiselect__select {
    width: calc(1.5em + 0.75rem + 2px);
    height: calc(1.5em + 0.75rem);
  }
  .multiselect__content {
    max-width: 100%;
  }
  .multiselect__tags {
    min-height: calc(1.5em + 0.75rem + 2px);
    height: calc(1.5em + 0.75rem + 2px);
    display: block;
    padding: 8px calc(1.5em + 0.75rem + 2px) 0 0.375rem;
    border-radius: 0.25rem;
    border: 1px solid #ced4da;
    background: #fff;
    font-size: 0.85rem;
  }
  .multiselect__single {
    font-size: 0.85rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .multiselect__placeholder {
    margin-bottom: 0em;
    font-size: 1rem;
    padding: 0;
  }
  .multiselect__input,
  .multiselect__single {
    margin-bottom: 0rem;
    font-weight: 500;
    color: #495057;
    font-weight: 500;
    min-height: 24px;
    line-height: 24px;
  }
  /* .multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #30c873; //#29a961;
} */
  .multiselect__element {
    font-size: 14px;
  }
  .has-error .multiselect__tags {
    border: 1px solid #d74e4e;
    padding-right: calc(1.5em + 0.75rem) !important;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23d74e4e' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23d74e4e' stroke='none'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem + 1.5rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }

  .option__entries {
    margin-left: 5px;
  }

  .option__small {
    font-size: 75%;
    color: var(--muted-color);
  }
  .practice-lookup-complete {
    .multiselect__option--highlight,
    .multiselect__option--highlight:after {
      background: var(--light-color);
      color: inherit;
    }

    // .multiselect__content .multiselect__element:first-child {
    //   .multiselect__option--highlight,
    //   .multiselect__option--highlight:after {
    //     background: inherit;
    //     color: inherit;
    //     cursor: default;
    //   }
    // }
  }

  .practice-lookup-complete .multiselect__option--highlight .option__small {
    color: inherit;
  }
}
</style>
